import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';

import { BetslipInfoComponent } from './components/digital/banker-help/betslip-info.component';
import { BetTypeInfoPopupComponent } from './components/digital/bet-type-info-popup/bet-type-info-popup.component';
import { CompetitionHeaderComponent } from './components/digital/competition-header/competition-header.component';
import { BetslipDialogFullService } from './services/betslip-dialog-full.service';

@NgModule({
    declarations: [CompetitionHeaderComponent, BetslipInfoComponent, BetTypeInfoPopupComponent],
    imports: [CommonModule, CompetitionLogoComponent],
    exports: [CompetitionHeaderComponent, BetslipInfoComponent, BetTypeInfoPopupComponent],
    providers: [BetslipDialogFullService],
})
export class BetslipDigitalCommonModule {}
